var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('frequencyDistributionForMicrobe',{attrs:{"chartData":_vm.chartData,"type":_vm.type,"title":"유해균"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }